// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PercentageSquareIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "PercentageSquare/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm-7.034 5.95c0-.675.55-1.234 1.234-1.234.675 0 1.233.55 1.233 1.234 0 .675-.55 1.233-1.233 1.233a1.241 1.241 0 0 1-1.234-1.233Zm.892 5.733a.618.618 0 0 1-.442-.183.629.629 0 0 1 0-.884l5.459-5.458a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-5.458 5.459a.618.618 0 0 1-.442.183Zm5.792.267c-.675 0-1.234-.55-1.234-1.234 0-.675.55-1.233 1.234-1.233.675 0 1.233.55 1.233 1.233a1.23 1.23 0 0 1-1.233 1.234Z"
}));
export default PercentageSquareIcon;